import { getApiBaseUrl } from "@/config/runtime";
import { getHeaders } from "@/lib/api";

/**
 * Downloads a chat attachment (an AI-generated artifact or any other
 * `/chat/attachments/{uuid}/file`-backed file) and triggers a browser
 * save-as via a temporary anchor + blob object URL.
 *
 * Shared by `ArtifactCard` (inline in chat) and the Project Hub's Artifacts
 * tab, which previously each hand-rolled this same fetch-blob-download
 * sequence and had already started to drift (inconsistent error handling).
 */
export async function downloadAttachment(
  source: { attachmentUuid?: string; url?: string },
  filename: string,
): Promise<void> {
  const url = source.attachmentUuid ? `${getApiBaseUrl()}/chat/attachments/${source.attachmentUuid}/file` : source.url;
  if (!url) {
    throw new Error("No download URL available for this attachment");
  }

  const headers = await getHeaders();
  headers.delete("Content-Type");

  const response = await fetch(url, { headers });
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
}
